'use strict';

var colorbrewer = require('lib/colorbrewer.js').colorbrewer;

function LiteDatamapOpts(gui, options) { this.$value = {}; }
LiteDatamapOpts.prototype = Object.create(Object.prototype);
LiteDatamapOpts.prototype.convert = function(options) { return options; }
LiteDatamapOpts.prototype.mergeSpecs = function(newSpecs) {}
LiteDatamapOpts.prototype.build = function() {}
LiteDatamapOpts.prototype.getValue = function() { return this.$value; }
LiteDatamapOpts.prototype.syncDisplay = function() {}
exports.LiteDatamapOpts = LiteDatamapOpts;
